import * as mutationType from "../mutation_types";
import _ from "lodash";

const state = {
  review_categories: [],
  annual_review_sections: [],
  annual_review_ratings: []
};

const getters = {
  review_categories: state => state.review_categories || [],
  review_questions: (state, getters) => {
    return _.flatten(getters.review_categories.map(x => x.questions));
  },
  active_review_questions: (state, getters) =>
    getters.review_questions.filter(x => x.isEnabled),
  annual_review_sections: state => state.annual_review_sections,
  annual_review_ratings: state => state.annual_review_ratings
};

const actions = {
  saveFeatures({ commit }, settings) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .put("/api/settings/features", settings)
        .then(res => {
          commit(`profile/${mutationType.SET_PROFILE_SETTINGS}`, res.data, {
            root: true
          });
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  saveReviewSettings({ commit }, settings) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .put("/api/settings/review", settings)
        .then(res => {
          commit(`profile/${mutationType.SET_PROFILE_SETTINGS}`, res.data, {
            root: true
          });
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  getReviewCategories({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get("/api/settings/review/categories")
        .then(res => {
          commit(mutationType.SET_SETTINGS_REVIEW_CATEGORIES, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  toggleReviewCategory({ commit }, category) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .put(
          `/api/settings/review/categories/${category.id}/toggle/${category.isEnabled}`
        )
        .then(() => {
          commit(mutationType.TOGGLE_SETTINGS_REVIEW_CATEGORY, category);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  toggleReviewQuestions({ commit }, category) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .put(`/api/settings/review/questions/toggle`, category)
        .then(res => {
          commit(mutationType.TOGGLE_SETTINGS_REVIEW_QUESTIONS, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  saveReviewQuestion({ commit }, question) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post("/api/settings/review/questions", question)
        .then(res => {
          commit(mutationType.SET_REVIEW_QUESTION, res.data);
          resolve(res.data.id);
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  deleteReviewQuestion({ commit }, question) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .delete(`/api/settings/review/questions/${question.id}`)
        .then(() => {
          commit(mutationType.REMOVE_REVIEW_QUESTION, question);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  saveReviewQuestionCategory({ commit }, category) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post("/api/settings/review/categories", category)
        .then(res => {
          commit(mutationType.SET_REVIEW_QUESTION_CATEGORY, res.data);
          resolve(res.data.id);
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  deleteReviewQuestionCategory({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .delete(`/api/settings/review/categories/${id}`)
        .then(res => {
          commit(mutationType.REMOVE_REVIEW_QUESTION_CATEGORY, id);
          resolve(res.data.id);
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  saveAnnualReviewSettings({ commit }, settings) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .put("/api/settings/annualreview", settings)
        .then(res => {
          commit(`user/${mutationType.SET_PROFILE_SETTINGS}`, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  getAnnualReviewSections({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get("/api/settings/annualreview/sections")
        .then(res => {
          commit(mutationType.SET_SETTINGS_ANNUAL_REVIEW_SECTIONS, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  saveAnnualReviewSection({ commit }, section) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post("/api/settings/annualreview/sections", section)
        .then(res => {
          section.id = res.data;
          commit(mutationType.SET_SETTINGS_ANNUAL_REVIEW_SECTION, section);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  deleteAnnualReviewSection({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .delete(`/api/settings/annualreview/sections/${id}`)
        .then(() => {
          commit(mutationType.REMOVE_SETTINGS_ANNUAL_REVIEW_SECTION, id);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  saveAnnualReviewQuestion({ commit }, question) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post("/api/settings/annualreview/questions", question)
        .then(res => {
          question.id = res.data;
          commit(mutationType.SET_SETTINGS_ANNUAL_REVIEW_QUESTION, question);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  deleteAnnualReviewQuestion({ commit }, question) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .delete(`/api/settings/annualreview/questions/${question.id}`)
        .then(() => {
          commit(mutationType.REMOVE_SETTINGS_ANNUAL_REVIEW_QUESTION, question);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  getAnnualReviewRatings({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get("/api/settings/annualreview/ratings")
        .then(res => {
          commit(mutationType.SET_SETTINGS_ANNUAL_REVIEW_RATINGS, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  saveAnnualReviewRatings({ commit }, ratings) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post("/api/settings/annualreview/ratings", ratings)
        .then(res => {
          commit(mutationType.SET_SETTINGS_ANNUAL_REVIEW_RATINGS, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  savePulseSettings({ commit }, settings) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .put("/api/settings/pulse", settings)
        .then(res => {
          commit(`profile/${mutationType.SET_PROFILE_SETTINGS}`, res.data, {
            root: true
          });
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  }
};

const mutations = {
  [mutationType.SET_SETTINGS_REVIEW_CATEGORIES](state, list) {
    state.review_categories = list;
  },
  [mutationType.TOGGLE_SETTINGS_REVIEW_CATEGORY](state, category) {
    let index = state.review_categories.findIndex(x => x.id == category.id);
    if (index >= 0) {
      state.review_categories[index].isEnabled = category.isEnabled;
      for (
        var i = 0;
        i < state.review_categories[index].questions.length;
        i++
      ) {
        state.review_categories[index].questions[i].isEnabled =
          category.isEnabled;
      }
    }
  },
  [mutationType.TOGGLE_SETTINGS_REVIEW_QUESTIONS](state, category) {
    let index = state.review_categories.findIndex(x => x.id == category.id);
    if (index >= 0) {
      state.review_categories[index].isEnabled = category.isEnabled;
      for (
        var i = 0;
        i < state.review_categories[index].questions.length;
        i++
      ) {
        var question = category.questions.find(
          x => x.id == state.review_categories[index].questions[i].id
        );
        if (question) {
          state.review_categories[index].questions[i].isEnabled =
            question.isEnabled;
        }
      }
    }
  },
  [mutationType.SET_REVIEW_QUESTION](state, question) {
    let index = state.review_categories.findIndex(
      x => x.id == question.categoryId
    );
    if (index >= 0) {
      var qIndex = state.review_categories[index].questions.findIndex(
        x => x.id == question.id
      );
      if (qIndex >= 0) {
        state.review_categories[index].questions[qIndex] = Object.assign(
          state.review_categories[index].questions[qIndex],
          question
        );
      } else {
        state.review_categories[index].questions.push(question);
      }
    }
  },
  [mutationType.REMOVE_REVIEW_QUESTION](state, question) {
    let index = state.review_categories.findIndex(
      x => x.id == question.categoryId
    );
    if (index >= 0) {
      var qIndex = state.review_categories[index].questions.findIndex(
        x => x.id == question.id
      );
      if (qIndex >= 0) {
        state.review_categories[index].questions.splice(qIndex, 1);
      }
    }
  },
  [mutationType.SET_REVIEW_QUESTION_CATEGORY](state, category) {
    var index = state.review_categories.findIndex(x => x.id == category.id);
    if (index >= 0) {
      state.review_categories[index] = Object.assign(
        state.review_categories[index],
        category
      );
    } else {
      state.review_categories.push(category);
    }
  },
  [mutationType.REMOVE_REVIEW_QUESTION_CATEGORY](state, id) {
    var index = state.review_categories.findIndex(x => x.id == id);
    if (index >= 0) {
      state.review_categories.splice(index, 1);
    }
  },
  [mutationType.ADD_SETTINGS_REVIEW_QUESTIONS](state, list) {
    list.forEach(item => {
      var index = state.review_questions.findIndex(x => x.id == item.id);
      if (index < 0) {
        state.review_questions.push(item);
      }
    });
  },
  [mutationType.REMOVE_SETTINGS_REVIEW_QUESTIONS](state, list) {
    state.review_questions = state.review_questions.filter(
      x => list.findIndex(y => y.id == x.id) < 0
    );
  },
  [mutationType.SET_SETTINGS_ANNUAL_REVIEW_SECTIONS](state, list) {
    state.annual_review_sections = list;
  },
  [mutationType.SET_SETTINGS_ANNUAL_REVIEW_SECTION](state, section) {
    if (!section.questions) {
      section.questions = [];
    }
    var index = state.annual_review_sections.findIndex(x => x.id == section.id);
    if (index < 0) {
      state.annual_review_sections.push(section);
    } else {
      state.annual_review_sections[index] = Object.assign(
        state.annual_review_sections[index],
        section
      );
    }
  },
  [mutationType.REMOVE_SETTINGS_ANNUAL_REVIEW_SECTION](state, id) {
    var index = state.annual_review_sections.findIndex(x => x.id == id);
    if (index >= 0) {
      state.annual_review_sections.splice(index, 1);
    }
  },
  [mutationType.SET_SETTINGS_ANNUAL_REVIEW_QUESTION](state, question) {
    var sIndex = state.annual_review_sections.findIndex(
      x => x.id == question.sectionId
    );
    if (sIndex >= 0) {
      var qIndex = state.annual_review_sections[sIndex].questions.findIndex(
        x => x.id == question.id
      );
      if (qIndex < 0) {
        state.annual_review_sections[sIndex].questions.push(question);
      } else {
        state.annual_review_sections[sIndex].questions[qIndex] = Object.assign(
          state.annual_review_sections[sIndex].questions[qIndex],
          question
        );
      }
    }
  },
  [mutationType.REMOVE_SETTINGS_ANNUAL_REVIEW_QUESTION](state, question) {
    var sIndex = state.annual_review_sections.findIndex(
      x => x.id == question.sectionId
    );
    if (sIndex >= 0) {
      var qIndex = state.annual_review_sections[sIndex].questions.findIndex(
        x => x.id == question.id
      );
      if (qIndex >= 0) {
        state.annual_review_sections[sIndex].questions.splice(qIndex, 1);
      }
    }
  },
  [mutationType.SET_SETTINGS_ANNUAL_REVIEW_RATINGS](state, list) {
    state.annual_review_ratings = list;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
